import React from 'react';
import { Icon } from './Icon.js';
export const IconBookmarkFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8.25,0H3.75C2.233,0,1,1.233,1,2.75v8.5c0,.285.162.546.418.672.255.127.562.097.788-.077l3.794-2.901,3.794,2.901c.133.102.294.154.456.154.113,0,.227-.025.332-.078.256-.126.418-.387.418-.672V2.75c0-1.517-1.233-2.75-2.75-2.75Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconBookmarkFill12.js.map